import React from 'react';
import './InputBox.scss';

const InputBox = ({
  type = 'text',
  name = '',
  placeholder = 'Enter text...',
  value = '',
  min,
  max,
  step,
  handleChange,
  disabled = false,
  readOnly = false,
  decimalAllowed = true, // NEW PROP
}) => {
  const onChange = (e) => {
    const newValue = e.target.value;

    if (type === 'number') {
      // Check if decimal is not allowed
      if (!decimalAllowed && newValue.includes('.')) {
        alert('Decimal values are not allowed.');
        return;
      }

      // Check min and max if newValue is a valid number
      const numericValue = parseFloat(newValue);
      if (newValue !== '' && !isNaN(numericValue)) {
        if (min !== undefined && numericValue < min) {
          alert(`Value should not be less than ${min}.`);
          return;
        }
        if (max !== undefined && numericValue > max) {
          alert(`Value should not be greater than ${max}.`);
          return;
        }
      }
    }

    if (handleChange) {
      handleChange(name, newValue);
    }
  };

  const inputProps = {
    type,
    name,
    value,
    onChange,
    placeholder,
    disabled, 
    readOnly,
    className: type === 'number' ? 'number-input' : 'text-input',
  };

  if (type === 'number') {
    if (min !== undefined) inputProps.min = min;
    if (max !== undefined) inputProps.max = max;
    if (step !== undefined) inputProps.step = step;
  }

  return (
    <div className="text-input-wrapper" style={type == 'number' ? { width: '100px' } : {width: '375px'}}>
      <input {...inputProps} />
    </div>
  );
};

export default InputBox;
